import type { CarryMemberHolding } from '@/types/carryFund';
import { CarryStructureTile } from './CarryStructureTile';

interface CarryMemberHoldingsBoxProps {
  holdings: CarryMemberHolding[];
  holdingPath?: (fundMemberId: string) => string;
}

export function CarryMemberHoldingsBox({
  holdings,
  holdingPath,
}: CarryMemberHoldingsBoxProps) {
  if (holdings.length === 0) {
    return null;
  }

  return (
    <div className="h-full rounded-lg border border-slate-300 bg-card p-4 dark:border-slate-700">
      <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
        Members — personal holding companies
      </p>
      <div className="mt-3 grid grid-cols-[repeat(auto-fit,minmax(178px,1fr))] gap-2">
        {holdings.map((holding) => (
          <CarryStructureTile
            key={holding.fund_member_id}
            to={holdingPath?.(holding.fund_member_id)}
            className="flex min-h-14 flex-col justify-center gap-0.5 overflow-hidden rounded-lg border border-blue-200 bg-blue-50 px-3 py-2.5 dark:border-blue-900 dark:bg-blue-950/30"
            hoverClassName="hover:bg-blue-100 dark:hover:bg-blue-950/50"
          >
            <p className="text-xs font-medium leading-tight text-blue-800 dark:text-blue-300">
              {holding.holding_name}
            </p>
            <p className="text-[11px] tabular-nums text-muted-foreground">
              CoC {holding.holding_coc_number ?? '—'}
            </p>
          </CarryStructureTile>
        ))}
      </div>
    </div>
  );
}
